export default "__VITE_ASSET__VIzyD2h9__"